export default [
    {
        path: '/',
        component: () => import(/* webpackChunkName: "js/pages/themes/home" */ '@views/pages/themes/default/home')
    },
    {
        path: '/home',
        component: () => import(/* webpackChunkName: "js/pages/themes/home" */ '@views/pages/themes/default/home')
    },
    {
        path: '/contact',
        component: () => import(/* webpackChunkName: "js/pages/themes/contact" */ '@views/pages/themes/default/contact')
    },
    {
        path: '/events',
        component: () => import(/* webpackChunkName: "js/pages/themes/events" */ '@views/pages/themes/default/events')
    },
    {
        path: '/calendar',
        component: () => import(/* webpackChunkName: "js/pages/themes/calendar" */ '@views/pages/themes/default/calendar')
    },
    {
        path: '/gallery',
        component: () => import(/* webpackChunkName: "js/pages/themes/gallery" */ '@views/pages/themes/default/gallery')
    },
    {
        path: '/articles',
        component: () => import(/* webpackChunkName: "js/pages/themes/articles/index" */ '@views/pages/themes/default/articles/index')
    },
    {
        path: '/articles/:uuid',
        component: () => import(/* webpackChunkName: "js/pages/themes/articles/show" */ '@views/pages/themes/default/articles/show')
    },
    {
        path: '/page/:page',
        component: () => import(/* webpackChunkName: "js/pages/themes/page" */ '@views/pages/themes/default/page')
    },
    {
        path: '/frontend/exam-payment',
        component: () => import(/* webpackChunkName: "js/frontend/exam-payment" */ '@views/frontend/exam-payment')
    },
    {
        path: '/frontend/exam-registration',
        component: () => import(/* webpackChunkName: "js/frontend/exam-registration" */ '@views/frontend/exam-registration')
    }
]